<div style="padding: 40px; min-height: 300px;" class="flex justify-center items-center flex-col relative">

    <button class="absolute top-2 right-2 p-2 hover:bg-gray-100 rounded-full" (click)="handleCloseDialog()">
        <i class="pi pi-times"></i>
    </button>

    <!-- Header Message -->
    <div *ngIf="!csvUploaded" class="text-center mb-6">
        <h3 class="text-xl font-semibold text-gray-800 mb-2">Bulk Import Contact Group</h3>
        <p class="text-gray-600 mb-4">Upload your CSV file to import multiple contacts at once</p>

        <!-- Download Sample CSV Button -->
        <button pButton label="Download Sample CSV" icon="pi pi-download" class="p-button-outlined p-button-info mb-4"
            (click)="downloadSampleCSV()">
        </button>
    </div>

    <!-- File upload section -->
    <div *ngIf="!csvUploaded" class="text-center drop-zone" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
      <p-fileUpload
  #fileUpload
  name="csvFile"
  accept=".csv"
  [customUpload]="true"
  [showUploadButton]="false"
  [showCancelButton]="false"
  [maxFileSize]="1000000"
  chooseLabel="Select CSV File"
  (onSelect)="onFileSelect($event)"
  (onClear)="onFileClear()"
  (onRemove)="onFileRemove($event)"
  [style]="{
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: '25px',
    paddingTop: '5px'
  }"
  class="mb-4 custom-upload"
>
  <ng-template pTemplate="content">
    <ng-container *ngIf="!csvFile">
      <div
        class="flex flex-column align-items-center"
        style="text-align: center; display: flex; width: 100%; justify-content: center; align-items: center; flex-direction: column; padding: 25px 80px;"
      >
        <i class="pi pi-file-import text-4xl mb-2"></i>
        <div class="upload-text">
          Drag and drop your CSV file here<br />
          <span class="text-sm text-gray-500">or click to browse</span>
        </div>
      </div>
    </ng-container>
  </ng-template>
</p-fileUpload>
    </div>

    <!-- Show dropdowns after CSV is uploaded -->
    <div *ngIf="csvUploaded" style="padding: 20px; width: 100%;">
        <h3 class="text-xl font-semibold text-gray-800 mb-4">Map CSV Columns</h3>
        <form [formGroup]="form" style="display: flex; flex-direction: column; gap: 20px;" (ngSubmit)="mapData()">

            <!-- Dropdown for selecting first_name -->
            <div class="fields">
                <label for="first_name">Select First Name Column</label>
                <p-select [options]="columns"
                appendTo="body"
                formControlName="first_name" placeholder="Select First Name Column">
                </p-select>
                <div *ngIf="isFieldInvalid('first_name')" class="text-danger">
                    First Name is required.
                </div>
            </div>

            <!-- Dropdown for selecting last_name -->
            <div class="fields">
                <label for="last_name">Select Last Name Column <span class="text-gray-500 text-sm">(Optional)</span></label>
                <p-select [options]="columns"
                appendTo="body"
                formControlName="last_name" placeholder="Select Last Name Column (Optional)">
                </p-select>
            </div>

            <!-- Dropdown for selecting email -->
            <div class="fields">
                <label for="email">Select Email Column</label>
                <p-select [options]="columns" 
                appendTo="body"
                formControlName="email" placeholder="Select Email Column">
                </p-select>
                <div *ngIf="isFieldInvalid('email')" class="text-danger">
                    Email is required.
                </div>
            </div>

            <!-- Dropdown for selecting phone -->
            <div class="fields">
                <label for="phone">Select Phone Column</label>
                <p-select [options]="columns"
                appendTo="body"
                formControlName="phone" placeholder="Select Phone Column">
                </p-select>
                <div *ngIf="isFieldInvalid('phone')" class="text-danger">
                    Phone is required.
                </div>
            </div>

            <!-- Buttons -->
            <div style="display: flex; gap: 10px; justify-content: flex-end;">
                <button pButton type="button" label="Back" icon="pi pi-arrow-left" class="p-button-secondary"
                    (click)="goBackToUpload()">
                </button>
                <button pButton type="submit" label="Submit" icon="pi pi-save" class="p-button-success"
                    [loading]="btnLoading"
                    [disabled]="btnLoading">
                </button>
            </div>
        </form>
    </div>
</div>